module.exports = __webpack_public_path__ + "img/not_found.287e12d7.gif";